export default __webpack_public_path__ + "static/media/Poppins-SemiBoldItalic.3524ffc3.ttf";